import { displayLayers } from './common.js';


export function display(id, layers){
	displayLayers(id, layers);
}
